var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loginLoading),expression:"loginLoading"}],staticClass:"identify-container h100"})
}
var staticRenderFns = []

export { render, staticRenderFns }